export default "__VITE_ASSET__By6Ky6YI__"